import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-privileges-list',
  templateUrl: './privileges-list.component.html',
  styleUrls: ['./privileges-list.component.css']
})
export class PrivilegesListComponent implements OnInit {

  cid: any
  form: any | FormGroup
  privilege: any = []
  page: number = 0;
  count: number = 0;
  first: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  screenPrivilegeList: any = []
  singlePrivilege: any = []
  deleteId: any = [];
  updatePrivilegeList: any = []
  screenPrivilegeScopeList: any = []
  buttonDisable = false
  menuId: any = ""
  screenSelect: any = [];
  screenIndex: any = 0
  isLoading: any = false

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  }

  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {
    let href: any = window.location.href;
    let messages = href.split('/')
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.getAllPrivileges()
    this.form = this.fb.group({
      groupName: [''],
      seqNo: [''],
    })

  }

  onTableDataChange(event: any) {
    this.page = event.page + 1;
    // this.getAllPrivileges();
  }


  addPrivilege() {
    this.buttonDisable = true
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "seqNo": String(this.form.get('seqNo').value),
      "groupName": String(this.form.get('groupName').value),
      "screenPrivilegeList": this.screenPrivilegeList,
      "cid": this.cid
    }

    this.generic_service.addPrivileges(body).subscribe(
      (response: any) => {
        this.getAllPrivileges()
        this.cancelModel()
        this.form.reset()
        this.toastr.success(response.message)
        this.buttonDisable = false
      },
      (error: any) => {
        console.log(error)
        this.buttonDisable = false
      }
    )
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  cancelAdd() {
    this.screenPrivilegeList = []
  }

  addScreenPrivilegeList() {
    this.screenPrivilegeList.push(
      {
        "seqNo": 0,
        "name": "",
        "description": "",
        "add": true,
        "view": true,
        "modify": true,
        "delete": true,
        "verify": true,
        "approve": true,
        "issue": true,
        "attach": true,
        "remove": true,
        "originalName": "",

        "screenPrivilegeScopeList": [
          {
            "controllerName": "",
            "type": "",
            "serverPrivilege": ""
          }
        ]
      }
    )
  }

  addScreenPrivilegeList1(i: any) {
    this.updatePrivilegeList[0].screenPrivilegeList.splice(i + 1, 0,
      {
        "seqNo": 0,
        "name": "",
        "description": "",
        "add": true,
        "view": true,
        "modify": true,
        "delete": true,
        "verify": true,
        "approve": true,
        "issue": true,
        "attach": true,
        "remove": true,
        "originalName": "",
        "screenPrivilegeScopeList": [
          {
            "controllerName": "",
            "type": "",
            "serverPrivilege": ""
          }
        ]
      }
    )
  }

  addScreenPrivilegeScopeList(i: any) {
    this.screenPrivilegeList[i].screenPrivilegeScopeList.push(
      {
        "controllerName": "",
        "type": "",
        "serverPrivilege": ""
      }
    )
  }

  removeScreenPrivilegeList(i: any) {
    this.updatePrivilegeList[0].screenPrivilegeList.splice(i, 1)
    console.log(this.screenPrivilegeList)
  }

  removeScreenPrivilegeScopeList(i: any, j: any) {
    this.screenPrivilegeList[i].screenPrivilegeScopeList.splice(j, 1)
  }

  getAllPrivileges() {
    this.isLoading = true
    this.generic_service.getAllPrivileges().subscribe(
      (response: any) => {
        console.log(response)
        this.privilege = response.response;
        for (let list of this.privilege) {
          console.log(list.screenGroupId + " : " + list.groupName)
        }
        this.count = response.response.length;
        this.isLoading = false

      }
    )
  }

  getPrivilegeById(id: any) {
    this.singlePrivilege = []
    this.generic_service.getPrivilegeById(id).subscribe(
      (res: any) => {
        console.log(res)
        this.singlePrivilege.push(res.response);
      }
    )
  }

  selectScreen(index: any) {
    this.screenIndex = index;
    this.screenSelect = this.singlePrivilege[0].screenPrivilegeList[index];
  }

  moveScreen() {
    let privilegeMenu: any;
    for (let i = 0; i < this.privilege.length; i++) {
      if (this.privilege[i].id == Number(this.menuId)) {
        privilegeMenu = this.privilege[i]
      }
    }
    privilegeMenu.screenPrivilegeList.push(this.screenSelect)
    this.singlePrivilege[0].screenPrivilegeList.splice(this.screenIndex, 1)


  }




  updatePrivilege() {
    let body = {
      "id": this.updatePrivilegeList[0].id,
      "screenGroupId": this.privilegeId,
      "version": Number(this.updatePrivilegeList[0].version),
      "isActive": this.updatePrivilegeList[0].isActive,
      "description": String(this.updatePrivilegeList[0].description),
      "seqNo": Number(this.updatePrivilegeList[0].seqNo),
      "groupName": String(this.updatePrivilegeList[0].groupName),
      "screenPrivilegeList": this.updatePrivilegeList[0].screenPrivilegeList,
      "cid": Number(this.cid)
    }
    console.log(body)
    this.generic_service.updatePrivilege(body).subscribe(
      (response: any) => {
        console.log(response);
        this.getAllPrivileges()
        this.toastr.success("Successfully updated");
        this.cancelModel()
      },
      (error: any) => {
        this.toastr.error(error.errors[0].description);
      }
    )
  }
  privilegeId: any
  getPrivilegeByID(id: any) {
    this.privilegeId = id
    this.generic_service.getPrivilegeById(id).subscribe(
      (res: any) => {
        this.updatePrivilegeList = [];
        // console.log(res);
        this.updatePrivilegeList.push(res.response)
        console.log(this.updatePrivilegeList);
      }
    )
  }


  deletePriviilege() {
    this.generic_service.deletePriviilege(this.deleteId).subscribe(
      (res: any) => {
        console.log(res)
        this.toastr.success("Successfully deleted");
        this.getAllPrivileges();
        this.cancelModel();
      }, err => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

  del(id: any) {
    this.deleteId = id
  }
}